import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';

@Directive({
    selector: '[responsive-button-large]',
    standalone: true,
})
export class ResponsiveButtonLargeDirective implements OnInit, OnDestroy {
  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private eleRef: ElementRef,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
  ) {}

  ngOnInit(): void {
    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(({ matchingAliases }) => {
        if (!matchingAliases.includes('md')) {
          this.eleRef.nativeElement.classList.add('fuse-mat-button-large');
        } else {
          this.eleRef.nativeElement.classList.remove('fuse-mat-button-large');
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.unsubscribe();
  }
}
